<script setup lang="ts">
  import { computed } from 'vue';
  import { ColoredButton, FieldSearchBar } from '@/shared/ui';
  import { usePermission } from '@/entities/Permission';
  import ShortTextIcon from '@/shared/assets/icons/ShortTextIcon.svg';
  import ExportExcelIcon from '@/shared/assets/icons/ExportExcel.svg';

  interface Props {
    canGenerateMatrix?: boolean;
    searchFieldId: string;
    searchTerm?: string;
    exportDisabled?: boolean;
    isExporting?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    canGenerateMatrix: false,
    searchTerm: '',
    exportDisabled: false,
    isExporting: false,
  });

  const emit = defineEmits<{
    'generate-matrix': [];
    'export-excel': [];
    'update:searchFieldId': [value: string];
    search: [term: string];
  }>();

  const { can } = usePermission();
  const canManageMatrix = computed(() => can('readMatrix', 'Training').value);

  const searchFields = [
    { id: 'cargo', name: 'Cargo' },
    { id: 'prefixo', name: 'Prefixo' },
    { id: 'titulo', name: 'Título' },
  ];
</script>

<template>
  <div
    data-testid="training-matrix-actions-bar"
    class="flex flex-col gap-4"
  >
    <div class="flex gap-3">
      <ColoredButton
        v-if="canManageMatrix"
        data-testid="btn-gerar-matriz"
        text="Gerar Matriz"
        :icon="ShortTextIcon"
        icon-alt="Gerar matriz"
        :disabled="!canGenerateMatrix"
        @click="emit('generate-matrix')"
      />
      <ColoredButton
        data-testid="btn-exportar-excel"
        text="Exportar para Excel"
        :icon="ExportExcelIcon"
        icon-alt="Exportar para Excel"
        :disabled="exportDisabled || isExporting"
        :loading="isExporting"
        @click="emit('export-excel')"
      />
    </div>

    <FieldSearchBar
      :search-field-id="searchFieldId"
      :search-fields="searchFields"
      :initial-search-term="searchTerm"
      independent-search-field
      class="w-full"
      @update:search-field-id="emit('update:searchFieldId', $event)"
      @search="emit('search', $event)"
    />
  </div>
</template>
